module.exports = __webpack_public_path__ + "img/manxing.f60c5024.png";